import { defineMessages } from 'react-intl';

export const scope = 'app.components.TipDirect.createTourModal';

export default defineMessages({
  tourName: {
    id: `${scope}.tourName`,
    defaultMessage: 'Tour Name'
  },
  longDesc: {
    id: `${scope}.longDesc`,
    defaultMessage: 'Long Description'
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Title'
  },
  createTour: {
    id: `${scope}.createTour`,
    defaultMessage: 'Create Tour'
  },
  updateTour: {
    id: `${scope}.updateTour`,
    defaultMessage: 'Update Tour'
  },
  inputLanguage: {
    id: `${scope}.input_language`,
    defaultMessage: 'Input Language'
  },
  inputLanguageDesc: {
    id: `${scope}.input_language_desc`,
    defaultMessage: 'Select which language this tour has been created in'
  },
  googleReviewURL: {
    id: `${scope}.google_review_url`,
    defaultMessage: 'Google Review URL'
  },
  tripAdvisorReviewURL: {
    id: `${scope}.tripadvisor_review_url`,
    defaultMessage: 'TripAdvisor Review URL'
  },
  tripAdvisorAnyLink: {
    id: `${scope}.tripadvisor_any_link`,
    defaultMessage:
      "Paste any TripAdvisor link for this tour, such as its page address. We'll turn it into the review link."
  },
  tripAdvisorLinkWithoutTour: {
    id: `${scope}.tripadvisor_link_without_tour`,
    defaultMessage:
      "That link doesn't point to a tour. Open the tour's page on TripAdvisor in a browser and copy the address from the address bar."
  },
  yelpReviewURL: {
    id: `${scope}.yelp_review_url`,
    defaultMessage: 'Yelp Review URL'
  },
  manageGuides: {
    id: `${scope}.manage_guides`,
    defaultMessage: 'Manage Guides'
  },
  importTitle: {
    id: `${scope}.import_title`,
    defaultMessage: 'Import from your website'
  },
  importSubtitle: {
    id: `${scope}.import_subtitle`,
    defaultMessage:
      "Paste a link to this tour on your site and we'll pull in the description for you to review."
  },
  importButton: {
    id: `${scope}.import_button`,
    defaultMessage: 'Import'
  },
  importing: {
    id: `${scope}.importing`,
    defaultMessage: 'Reading…'
  },
  imported: {
    id: `${scope}.imported`,
    defaultMessage: 'Imported — please review and edit before saving.'
  },
  importedViaReader: {
    id: `${scope}.imported_via_reader`,
    defaultMessage:
      'Imported. That page looked JavaScript-heavy, so double-check the details.'
  },
  importSoftNotFound: {
    id: `${scope}.import_soft_not_found`,
    defaultMessage:
      "That link looks like a 'page not found' page. Check the URL and try again."
  },
  importEmpty: {
    id: `${scope}.import_empty`,
    defaultMessage:
      "We reached the page but couldn't find a description to import. Try a different URL or fill it in below."
  },
  importFailed: {
    id: `${scope}.import_failed`,
    defaultMessage:
      "We couldn't read that page. Check the address, or just fill in the details below."
  }
});
